module.exports = __webpack_public_path__ + "static/scale-model-of-information-in-boulder-colorado-033f08c12f58dbaa38474b4f0b612ec8.png";